var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 84,
    viewBox: "0 0 100 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7199 67.8101C45.3899 67.8101 41.8799 71.3201 41.8799 75.6501C41.8799 79.9801 45.3899 83.4901 49.7199 83.4901C54.0499 83.4901 57.5599 79.9801 57.5599 75.6501C57.5599 71.3201 54.0499 67.8101 49.7199 67.8101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.56 26.21C88.36 9.8 69.83 0 49.98 0C30.13 0 11.44 9.88 0.26001 26.44C-0.19999 27.13 -0.0199901 28.06 0.66001 28.52C0.92001 28.69 1.21001 28.78 1.50001 28.78C1.98001 28.78 2.45001 28.55 2.74001 28.12C13.37 12.39 31.03 3 49.98 3C68.93 3 86.44 12.31 97.08 27.91C97.55 28.59 98.48 28.77 99.16 28.3C99.84 27.83 100.02 26.9 99.55 26.22L99.56 26.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.98 22.1001C35.89 22.1001 23.05 29.8501 16.47 42.3201C16.08 43.0501 16.36 43.9601 17.1 44.3501C17.83 44.7401 18.74 44.4601 19.13 43.7201C25.19 32.2401 37.01 25.1001 49.99 25.1001C62.97 25.1001 74.84 32.2601 80.89 43.7901C81.16 44.3001 81.68 44.5901 82.22 44.5901C82.46 44.5901 82.69 44.5301 82.92 44.4201C83.65 44.0401 83.94 43.1301 83.55 42.4001C76.98 29.8801 64.13 22.1001 50 22.1001H49.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9799 44.9199C41.4199 44.9199 34.2099 51.5999 33.5499 60.1199C33.4899 60.9499 34.1099 61.6699 34.9299 61.7299C35.7599 61.7899 36.4799 61.1799 36.5399 60.3499C37.0699 53.3799 42.9799 47.9199 49.9699 47.9199C56.9599 47.9199 62.9799 53.4599 63.4199 60.5399C63.4699 61.3299 64.1299 61.9499 64.9199 61.9499C64.9499 61.9499 64.9799 61.9499 65.0099 61.9499C65.8399 61.8999 66.4699 61.1899 66.4099 60.3599C65.8699 51.6999 58.6499 44.9199 49.9699 44.9199H49.9799Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_1037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.82,
    height: 83.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalIcon);
export default __webpack_public_path__ + "static/media/signal-icon.9c4568e6fa6bc0fadd7fd2650587843e.svg";
export { ForwardRef as ReactComponent };